export default __webpack_public_path__ + "static/media/img_in_frame.5cae2c81.png";